import { render, staticRenderFns } from "./NewsBlog.vue?vue&type=template&id=453ca742&"
import script from "./NewsBlog.vue?vue&type=script&lang=js&"
export * from "./NewsBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports